import React from "react";
import {Image} from "../../../../components/Image";
import "./style.css";

const GOALS = [
    {
        value: "lose_weight",
        title: "Lose weight",
        image: "/static/image/questionnaire/fasting/mainGoal/goal-lose-weight.png",
        className: "fasting-main-goal-card-lose-weight"
    },
    {
        value: "get_healthier",
        title: "Get healthier",
        image: "/static/image/questionnaire/fasting/mainGoal/goal-get-healthier.png",
        className: "fasting-main-goal-card-get-healthier"
    },
    {
        value: "stay_in_shape",
        title: "Stay in shape",
        image: "/static/image/questionnaire/fasting/mainGoal/goal-stay-shape.png",
        className: "fasting-main-goal-card-stay-shape"
    }
];

export const MainGoal = ({clickNext = () => {}}) => {
    return (
        <div className="gallery-page fasting-main-goal-page">
            <div className="fasting-main-goal-title-wrap">
                <h1 className="fasting-main-goal-title">What is your main goal?</h1>
            </div>

            <div className="fasting-main-goal-list">
                {GOALS.map((goal) => (
                    <button
                        type="button"
                        className={`fasting-main-goal-card ${goal.className}`}
                        key={goal.value}
                        onClick={() => {
                            clickNext(goal.value);
                        }}
                    >
                        <span className="fasting-main-goal-label">{goal.title}</span>
                        <span className="fasting-main-goal-image-wrap">
                            <Image
                                src={goal.image}
                                alt=""
                                className="fasting-main-goal-image"
                                defaultLoad={true}
                            />
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
};
